import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import {Headers, RequestOptions} from '@angular/http';
import { BatchUploadHistoryService } from './batch-upload-history.service';
import { BatchUploadHistory } from './batch-upload-history';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { UtilsService } from '../../shared/utils-service';

@Component({
  selector: 'app-batch-upload-history',
  templateUrl: './batch-upload-history.component.html',
  styleUrls: ['./batch-upload-history.component.css']
})
export class BatchUploadHistoryComponent implements OnInit {

	private batchDetails: any = {};
	private batchDetailsList: BatchUploadHistory[] = [];
	jsonRes: any = {};
	private loggedInUser: any = {};
	private url: string = "http://localhost:8080/DDMF/bulkBlackListSubmission/batchBulkListSubmissionSearch";
	
  constructor(private batchUploadHistoryService: BatchUploadHistoryService, private http: Http, private utils: UtilsService) {
  	this.searchBatchDetails();
  	this.loggedInUser = this.utils._checkSession({'page': 'mass-submit-telco'});
   }

  ngOnInit() {
  		
  }
  
  searchBatchDetails(){
  	//console.log(this.batchDetails);
  	let req = {
  		"userId" : this.loggedInUser.userId,
  		"batchId" : this.batchDetails.batchId,
  		"fileName" : this.batchDetails.fileName,
  		"status" : this.batchDetails.status,
  		"dateRangeFrom" : this.batchDetails.dateRangeFrom,
  		"dateRangeTo" : this.batchDetails.dateRangeTo
  		
  	};
  	//console.log(req);
  	this.batchUploadHistoryService.searchBatchDetails(req).subscribe(data => this.jsonRes = data);
  	if(this.jsonRes.batchList!=null)
  	{
  		this.batchDetailsList = this.jsonRes.batchList;
  	}
  	//console.log(this.batchDetailsList);
  }
}


// WEBPACK FOOTER //
// ./src/app/mass-submit-telco/batch-upload-history/batch-upload-history.component.ts